import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IRunCampaignPayload } from '@app-store/slices/campaigns/runCampaign'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IRunCampaignPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.campaigns.runCampaign

function* runCampaignSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/notifications/campaigns/run-campaign/${payload.campaignId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(payload?.sagaCB?.onSucccess())
            notification.success({
                message: 'Campaign published successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* runCampaignSaga(): any {
    yield takeLatest<TaskAction>(onRequest, runCampaignSagaTask)
}

export default runCampaignSaga
